<template>
  <li
    class="nav-item has-sub"
    :class="{
      'open': isGroupOpen,
      'disabled': item.disabled,
      'sidebar-group-active': sidebarGroupActive,
      'nav-item-group-collapsed': isVerticalMenuCollapsed,
      'nav-item-group-user-avatar': item.avatar
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <feather-icon v-if="!item.avatar" :icon="item.icon || 'CircleIcon'" class="icons-avatar"  />
      <b-avatar v-if="item.avatar" :src="item.avatar" class="mr-1" size="sm"></b-avatar>
      <span class="menu-title text-truncate name-user" v-if="!isVerticalMenuCollapsed">{{ item.i18n ? $t('MAIN_MENU')[item.i18n] : item.title }}</span>
      <b-badge
        v-if="item.tag"
        
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse
      v-model="isOpen"
      class="menu-content menu-default"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse, BImg, BAvatar } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'

// import { ref } from '@vue/composition-api'

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup'
import AppConstants from '@/appConstants'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    BImg,
    BAvatar,
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  watch: {
    "$route.path"(val) {
      // console.log('$route.path: ', val);
      if (val != AppConstants.NAVIGATION_PAGE_MANAGE_NEWS && this.item.isEventStatus) {
        this.updateGroupOpen(false);
      } else if (this.item.isEventStatus && 
        this.isCurrentManageNewsPath) {
        this.updateGroupOpen(true);
      }
    }
  },
  computed: {
    isVerticalMenuCollapsed() {
      return this.$store.state.verticalMenu.isVerticalMenuCollapsed;
    },
    isGroupOpen() {
      if (this.item.isEventStatus && this.isCurrentManageNewsPath) {
        return true;
      }
      return this.isOpen;
    },
    sidebarGroupActive() {
      if (this.item.isEventStatus && this.isCurrentManageNewsPath) {
        return true;
      }
      return this.isActive;
    },
    isCurrentManageNewsPath() {
      return this.$route.path == AppConstants.NAVIGATION_PAGE_MANAGE_NEWS;
    }
  },
  setup(props) {
    
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item)

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    }
  },
}
</script>

<style>

</style>
